module.exports = __webpack_public_path__ + "media/images/footer-background-3f871fb3.svg";